import { makeCatchIssueUseCase } from "../catch-issue.factory";
import { axiosNestJsInstance } from "@mais-retorno-front/configs/axios-config";
import { GetAllBookmarkContentDetailsFormattedUseCase } from "@mais-retorno-front/core-business/useCases/bookmark-content/get-all-bookmark-content-details-formatted.usecase";
import { getPodcastBySlug, getPostBySlug, getTermBySlug, getVideoBySlug } from "@mais-retorno-front/graphQl/queries/bookmark-content";

const catchIssueUseCase = makeCatchIssueUseCase();

export const makeGetAllBookmarkContentDetailsFormattedUseCase = () => {
  const url = "/bookmarks/content";
  
  return new GetAllBookmarkContentDetailsFormattedUseCase(
    url,
    axiosNestJsInstance,
    getPostBySlug,
    getPodcastBySlug,
    getVideoBySlug,
    getTermBySlug,
    catchIssueUseCase,
  )
}